// 빌드: ./fe-build.sh voice
import 'es6-promise/auto'
import Vue from 'vue'
import Axios from 'axios'
import Pager from './components/common/pagingUser.vue';
import Common from './components/ynadmin/common/common.js';
import swal from 'sweetalert';
import Editor from "./components/common/editor.vue";
import validation from 'validator';
import VueFileAgent from 'vue-file-agent';
import 'vue-file-agent/dist/vue-file-agent.css';
import Share from './components/common/share.js';
import mobile from 'is-mobile';
import DropImg from "./components/common/dragImgFile.vue";
import DropDoc from "./components/common/dragDocFile.vue";
import DropVideo from "./components/common/dragVideoFile.vue";
import SwalAlert from "./components/common/swalAlert.vue";

Vue.use(VueFileAgent);
Vue.use(mobile);

Vue.component("pager", Pager);
Vue.component('editor', Editor);
Vue.component('dropimg', DropImg);
Vue.component('dropdoc', DropDoc);
Vue.component('dropvideo', DropVideo);

Vue.prototype.$http = Axios;
Vue.prototype.$pager = Pager;
Vue.prototype.$common = Common;

// 활동지도 목록 상태 저장 키 & 상세 뒤로가기 복원 플래그
const ACT_MAP_STATE_KEY = 'ACT_MAP_STATE';
const ACT_MAP_BACK_INTENT_KEY = 'ACT_MAP_BACK_INTENT';

new Vue({
  el: '#activitymap',
  data: function () {
    return {
      mainName: '청소년 활동지도',
      showAcc: '',
      isShare: false,
      isMobile: false,
      fpt: '',
      listBanner: [],
      inputLabel: '',
      navName: '',
      areaName: '서울시 청소년시설',
      areaName2: '서울시',
      activityKind: 'all',

      tabIdx: '',
      isMapExpanded: true,  // 지도 확대 상태 추적 (true: 열림, false: 닫힘)
      isMobileStyle: {
        'width': '100%',
        //'height' : '250px'
        'height': 'auto'
      },
      isMobileStyles: {
        'height': 'auto'
      },

      mapListModel: {
        list: [],
        areaGuid: 'all',
        totalCount: 0,
        showMore: false,
      },

      expInfoListModel:{
        list : [],
        //베스트활동, 비대면활동
        areaGuid : 'all',
        activityKind: 'all',
        activityGuid : '',
        order : 'newest',

        //맞춤활동검색
        scopeList: [],
        progressList: [],
        areaList: [],
        affList: [],
        priceList: [
          {
            "cmm_sys_cd": "price2",
            "cmm_sys_titl": "무료"
          },
          {
            "cmm_sys_cd": "price3",
            "cmm_sys_titl": "~ 5,000"
          },
          {
            "cmm_sys_cd": "price4",
            "cmm_sys_titl": " 5,000 ~ 10,000"
          },
          {
            "cmm_sys_cd": "price5",
            "cmm_sys_titl": "10,000 ~ 30,000"
          },
          {
            "cmm_sys_cd": "price6",
            "cmm_sys_titl": "30,000 ~"
          }
        ],

        totalCount : 0,
        showMore: false,
        pager: {
          model: {},
          pageNo: 1,
          pageNum:1,
          totalSize: 0,
          rowSize: 8,
          blockSize: 10,
          endSize:0,
          list: [],
          href:"#",
          callBack: function (n) {
            this.model.fnOnActivityExpProgramList(n);
          }
        }
      },
      viewModel:{
        list:[],
        detail:[],
        target:[],
        targetName : '',
        totalCount:0,
        checkedValues:[],
        programType : 'program',
        pager: {
          model: {},
          pageNo: 1,
          totalSize: 0,
          rowSize: 10,
          blockSize: 10,
          list: [],
          href:"#",
          callBack: function (n) {
            this.model.fnOnPostList(n);
          }
        }
      },
      searchStr: [ "", "", "", "", "", "", "", "", ""],
      viewYnModel: {
        price: '',
        progress: '',
        trget: '',
        affiliation: '',
        capacity: ''
      },
    }
  },
  created: function () {
    this.isMobile = mobile();
    if (!('$' in Vue.prototype) && '$' in window) {
        Vue.prototype.$ = window.$; // <template> 에서 $ 사용
    }
  },
  mounted: function () {
    try {
      // 히스토리 뒤로가기 복원 시도 (상세 -> 목록)
      let restored = false;
      try {
        const path = (window.location && window.location.pathname) ? window.location.pathname.replace(/\/+$/, '') : '';
        const isListPage = path === '/customer/activityMap';
        const fromDetail = sessionStorage.getItem(ACT_MAP_BACK_INTENT_KEY) === '1';
        let isBack = false;
        try {
          const nav = (performance && performance.getEntriesByType) ? performance.getEntriesByType('navigation') : null;
          if (nav && nav.length && nav[0].type === 'back_forward') {
            isBack = true;
          } else if (window.performance && window.performance.navigation) {
            isBack = (window.performance.navigation.type === 2);
          }
        } catch(e) {}
        if (isListPage && fromDetail && isBack) {
          restored = this.restoreActivityMapState();
          sessionStorage.removeItem(ACT_MAP_BACK_INTENT_KEY); // 1회성
        }
      } catch(e){ console.log('[ACT_MAP] restore check error', e); }

      if (!restored) {
        this.fnOnLoadInit();
      }
    } catch (e) {
      console.log(e);
    }
  },
  filters: {
    currency: function (value) {
      let num = new Number(value);
      return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
    }
  },
  methods: {
    fnOnLoadInit:function(){
      let vm = this;
      vm.fnOnSetCode('DIVNVSCLNV000000'); // 대상 ('scope');
      vm.fnOnSetCode('IXVNV00000'); // 진행상태 ('progress');
      vm.fnOnSetCode('CPCNVADMNV000000'); // 역량 ('area');
      vm.fnOnSetCode('AFLNVADMNV000000'); // 계열 ('aff');

      let search = $("#search").val();
      if (search)
      {
        vm.searchStr = search.split("_");

        vm.expInfoListModel.areaGuid = vm.searchStr[0];
        vm.expInfoListModel.activityGuid = vm.searchStr[1];
        vm.expInfoListModel.activityKind = vm.searchStr[2];
        vm.areaName = vm.searchStr[3];
        vm.areaName2 = vm.searchStr[4];
        vm.tabIdx = vm.searchStr[0];
        vm.activityKind = vm.searchStr[2];

        // 20260319 활동지도 세팅시 권역값이 있으면 해당 권역 외 나머지 회색처리
        let EL = $('#ch_map');
        EL.removeClass('bgnowon bgmapo bggruo bggangnam');
        if(vm.tabIdx == 'GU0002'){
          // 동북권이 선택되었을 경우
          EL.hasClass('bgnowon') ? '' : EL.addClass('bgnowon');
        }else if(vm.tabIdx == 'GU0003'){
          // 서북권이 선택되었을 경우
          EL.hasClass('bgmapo') ? '' : EL.addClass('bgmapo');
        }else if(vm.tabIdx == 'GU0004'){
          // 서남권이 선택되었을 경우
          EL.hasClass('bggruo') ? '' : EL.addClass('bggruo');
        }else if(vm.tabIdx == 'GU0005'){
          // 동남권이 선택되었을 경우
          EL.hasClass('bggangnam') ? '' : EL.addClass('bggangnam');
        }




        if (vm.searchStr[7])
        {
          vm.expInfoListModel.priceList.forEach((item) => {
            if (vm.searchStr[7] == item.cmm_sys_cd)
            {
              vm.viewYnModel.price = item;
            }
          });
        }

        let param;
        param = {
          areaGuid: vm.searchStr[0]
        };

        if (vm.searchStr[2] != 'all')
        {
          param = {
            areaGuid: vm.searchStr[0],
            activityKind: vm.searchStr[2]
          };
        }
        // vm.funLocationBarUpdate({pageNum: pageNumber, qnaType: null})
        Axios.post("/customer/activityMap/list", param).then(function (response) {
          vm.mapListModel.list = [];
          vm.mapListModel.list = vm.mapListModel.list.concat(response.data.list);
        }).catch(function (ex) {
          console.log(ex);
        });

        vm.fnOnActivityExpProgramList(1, search);
      }
      else
      {
        vm.fnOnActivityList('all', '');
      }
    },
    fnOnActivityListClose: function ()
    {
      const vm = this;
      // tabIdx는 유지하고 확대 상태만 닫음으로 변경
      this.isMapExpanded = false;
      // 2026-03-19 권역 전체 회색처리 제거
      let EL = $('#ch_map');
      EL.removeClass('bgnowon bgmapo bggruo bggangnam');
      vm.fnOnActivityList('all', '서울시');
    }
    , fnOnSetCode: function (_code) {
      let vm = this;
      let param = {searchCode: _code};

      Axios.post("/api/expinfo/code", param).then(function (response) {

        if (_code === 'DIVNVSCLNV000000') {
          vm.expInfoListModel.scopeList = response.data.expinfoCodeList;
          if (vm.searchStr[5])
          {
            vm.expInfoListModel.scopeList.forEach(function (item) {
              if (vm.searchStr[5] == item.cmm_sys_cd)
              {
                vm.viewYnModel.trget = item;
              }
            })
          }
          // }else if(_code === 'STSNVAPRNV000100'){
        } else if (_code === 'IXVNV00000') {
          // 조성이 팀장님 요청으로 오류, 일시신청중지 삭제
          vm.expInfoListModel.progressList = [];
          response.data.expinfoCodeList.forEach(function(item) {
            if(item.cmm_sys_cd != 'IXVNV00006' && item.cmm_sys_cd != 'IXVNV00009') {
              vm.expInfoListModel.progressList.push(item);
            }
          });

          if (vm.searchStr[8])
          {
            vm.expInfoListModel.progressList.forEach(function (item) {
              if (vm.searchStr[8] == item.cmm_sys_cd)
              {
                vm.viewYnModel.progress = item;
              }
            })
          }
          //vm.expInfoListModel.progressList = response.data.expinfoCodeList;
        } else if (_code === 'CPCNVADMNV000000') {
          vm.expInfoListModel.areaList = response.data.expinfoCodeList;
        } else if (_code === 'AFLNVADMNV000000') {
          vm.expInfoListModel.affList = response.data.expinfoCodeList;
          if (vm.searchStr[6])
          {
            vm.expInfoListModel.affList.forEach(function (item) {
              if (vm.searchStr[6] == item.cmm_sys_cd)
              {
                vm.viewYnModel.affiliation = item;
              }
            })
          }
        } else if (_code === 'ESGNVMNGNV00000') {
          vm.expInfoListModel.esgList = response.data.expinfoCodeList;
        } else if (_code === 'SCHDNVYTHNV00000') {
          vm.expInfoListModel.planList = response.data.expinfoCodeList;
          if (vm.expInfoListModel.planList.length > 0) {
            vm.expInfoListModel.planList.forEach(function (object) {
              if (object.cmm_sys_cd === response.data.expinfoCodeList.cmm_sys_cd) {
                vm.selectPlanType = object;
              }
            });
          }
        }

      }).catch(function (ex) {
        console.log(ex);
      });
    },
    allReset: function () {
      let vm = this;
      vm.viewYnModel.trget = null;
      vm.viewYnModel.affiliation = null;
      vm.viewYnModel.capacity = null;
      vm.viewYnModel.price = null;
      vm.viewYnModel.progress = null;

      vm.fnOnActivityExpProgramList(1);
    },
    fnOnActivityList: function (areaGuid, areaName) {
      const vm = this;
      vm.tabIdx = areaGuid;
      vm.isMapExpanded = true;  // 지역 선택 시 지도 확대
      vm.activityKind = 'all';

      // 2026-03-19 지역 선택시 선택된 권역외 회색처리 되도록 적용
      let EL = $('#ch_map');
      EL.removeClass('bgnowon bgmapo bggruo bggangnam');
      if(areaGuid == 'all'){
        // 모든권역 선택일 경우
      }else if(areaGuid == 'GU0002'){
        // 동북권이 선택되었을 경우
        EL.hasClass('bgnowon') ? '' : EL.addClass('bgnowon');
      }else if(areaGuid == 'GU0003'){
        // 서북권이 선택되었을 경우
        EL.hasClass('bgmapo') ? '' : EL.addClass('bgmapo');
      }else if(areaGuid == 'GU0004'){
        // 서남권이 선택되었을 경우
        EL.hasClass('bggruo') ? '' : EL.addClass('bggruo');
      }else if(areaGuid == 'GU0005'){
        // 동남권이 선택되었을 경우
        EL.hasClass('bggangnam') ? '' : EL.addClass('bggangnam');
      }
      
      const param = {
        areaGuid: areaGuid
      };

      if (areaName)
      {
        vm.areaName = areaName;
        vm.areaName2 = areaName;
      }

      // vm.funLocationBarUpdate({pageNum: pageNumber, qnaType: null})
      Axios.post("/customer/activityMap/list", param).then(function (response) {
        vm.mapListModel.list = [];
        
        // 응답 데이터 유효성 검사
        if (response.data && Array.isArray(response.data.list)) {
          vm.mapListModel.list = vm.mapListModel.list.concat(response.data.list);
          /*
          if (vm.mapListModel.list.length > 0) {
            vm.fnOnActivityMapList('all', '');
          }
          */
         vm.fnOnActivityMapList('all', ''); // 데이터가 없을때도 프로그램 목록이 반영되도록 적용
        } else {
          console.error('[ActivityMap] Invalid response data:', response.data);
          swal('데이터를 불러올 수 없습니다', '잠시 후 다시 시도해주세요.', 'warning');
        }

      }).catch(function (ex) {
        console.error('[ActivityMap] API error:', ex);
        swal('서버 오류', '시설 목록을 불러오는 중 오류가 발생했습니다.', 'error');
      });
    },
    fnOnActivityKindList: function (type) {
      const vm = this;
      this.activityKind = type;

      const param = {
        areaGuid: this.tabIdx,
        activityKind: this.activityKind
      };

      Axios.post("/customer/activityMap/list", param).then(function (response) {
        vm.mapListModel.list = [];
        
        // 응답 데이터 유효성 검사
        if (response.data && Array.isArray(response.data.list)) {
          vm.mapListModel.list = vm.mapListModel.list.concat(response.data.list);
          /*
          if (vm.mapListModel.list.length > 0) {
            vm.fnOnActivityMapList('all', '');
          }
          */
          vm.fnOnActivityMapList('all', ''); // 데이터가 없을때도 프로그램 목록이 반영되도록 적용
        } else {
          console.error('[ActivityMap] Invalid response data:', response.data);
          swal('데이터를 불러올 수 없습니다', '잠시 후 다시 시도해주세요.', 'warning');
        }

      }).catch(function (ex) {
        console.error('[ActivityMap] API error:', ex);
        swal('서버 오류', '시설 목록을 불러오는 중 오류가 발생했습니다.', 'error');
      });
    },
    fnOnActivityMapList: function (activityGuid, centerName)
    {
      const vm = this;

      if (centerName)
      {
        vm.areaName = centerName;
      }

      vm.viewYnModel.trget = null;
      vm.viewYnModel.affiliation = null;
      vm.viewYnModel.capacity = null;
      vm.viewYnModel.price = null;
      vm.viewYnModel.progress = null;

      vm.expInfoListModel.list = [];
      vm.expInfoListModel.areaGuid = this.tabIdx;
      vm.expInfoListModel.activityKind = this.activityKind;
      vm.expInfoListModel.activityGuid = activityGuid;

      vm.fnOnActivityExpProgramList(1);
    },
    fnOnActivityExpProgramList: function (pageNumber, search) {
      const vm = this;
      vm.expInfoListModel.pager.pageNo = pageNumber;

      if (pageNumber == 1)
      {
        vm.expInfoListModel.list = [];
      }

      let param;
      if (search) {
        param = {
          areaGuid: vm.searchStr[0],
          activityGuid: vm.searchStr[1],
          activityKind: vm.searchStr[2],
          pageNo : vm.expInfoListModel.pager.pageNo,
          pageSize : vm.expInfoListModel.pager.rowSize
          , trget: vm.searchStr[5]
          , affiliation: vm.searchStr[6]
          , capacity: vm.viewYnModel.capacity ? vm.viewYnModel.capacity.cmm_sys_cd : ''
          , pricetype: vm.searchStr[7]
          , progress: vm.searchStr[8]
        };
      }
      else
      {
        param = {
          areaGuid: vm.expInfoListModel.areaGuid,
          activityGuid: vm.expInfoListModel.activityGuid,
          activityKind: vm.expInfoListModel.activityKind,
          pageNo : vm.expInfoListModel.pager.pageNo,
          pageSize : vm.expInfoListModel.pager.rowSize
          , trget: vm.viewYnModel.trget ? vm.viewYnModel.trget.cmm_sys_cd : ''
          , affiliation: vm.viewYnModel.affiliation ? vm.viewYnModel.affiliation.cmm_sys_cd : ''
          , capacity: vm.viewYnModel.capacity ? vm.viewYnModel.capacity.cmm_sys_cd : ''
          , pricetype: vm.viewYnModel.price ? vm.viewYnModel.price.cmm_sys_cd : ''
          , progress: vm.viewYnModel.progress ? vm.viewYnModel.progress.cmm_sys_cd : ''
        };
      }

      // vm.funLocationBarUpdate({pageNum: pageNumber, qnaType: null})
      Axios.post("/customer/activityMap/exinfolist", param).then(function (response) {

        vm.expInfoListModel.pager.totalSize = response.data.totalCount;
        vm.expInfoListModel.pager.pageNum = (vm.expInfoListModel.pager.pageNo * vm.expInfoListModel.pager.rowSize) - vm.expInfoListModel.pager.rowSize;

        response.data.expinfoList.forEach(function (item) {
          item.isZzim = item.zzimYn === "Y";
          item.startDate = item.startDate.split(' ')[0].replaceAll('-','.');
          item.endDate = item.endDate.split(' ')[0].replaceAll('-','.');
          if(item.filePath != null) {
            item.filePath = item.filePath.replaceAll('/var/uploadfiles', '');
          }
          vm.expInfoListModel.list.push(item);
        });

        Pager.props = Pager.methods.createPager(vm.expInfoListModel.pager, vm, "list");

        if (response.data.totalCount > 0)
        {
          vm.expInfoListModel.showMore = true;
        }
        else
        {
          vm.expInfoListModel.showMore = false;
        }

        // 상태 저장 (뒤로가기 복원 대비)
        vm.saveActivityMapState(true);
      }).catch(function (ex) {
        console.log(ex);
      });
    }
    //페이지 이동
    , fnGotoSearch() {
      let vm = this;
      let search = vm.expInfoListModel.areaGuid + "_" + vm.expInfoListModel.activityGuid + "_" + vm.expInfoListModel.activityKind + "_" + vm.areaName + "_"+ vm.areaName2 + "_";

      search = search + (vm.viewYnModel.trget ? vm.viewYnModel.trget.cmm_sys_cd : "") + "_";
      search = search + (vm.viewYnModel.affiliation ? vm.viewYnModel.affiliation.cmm_sys_cd : "") + "_";
      search = search + (vm.viewYnModel.price ? vm.viewYnModel.price.cmm_sys_cd : "") + "_";
      search = search + (vm.viewYnModel.progress ? vm.viewYnModel.progress.cmm_sys_cd : "");

      location.href = "/customer/activityMap?search=" + encodeURIComponent(search);
    }
    ,fnGotoDetailP(uid){
      let vm = this;
      let search = vm.expInfoListModel.areaGuid + "_" + vm.expInfoListModel.activityGuid + "_" + vm.expInfoListModel.activityKind + "_" + vm.areaName + "_"+ vm.areaName2 + "_";

      search = search + (vm.viewYnModel.trget ? vm.viewYnModel.trget.cmm_sys_cd : "") + "_";
      search = search + (vm.viewYnModel.affiliation ? vm.viewYnModel.affiliation.cmm_sys_cd : "") + "_";
      search = search + (vm.viewYnModel.price ? vm.viewYnModel.price.cmm_sys_cd : "") + "_";
      search = search + (vm.viewYnModel.progress ? vm.viewYnModel.progress.cmm_sys_cd : "");

      // 상세 이동 전 목록 상태 저장 + 복원 플래그 세팅
      try {
        vm.saveActivityMapState(true);
        sessionStorage.setItem(ACT_MAP_BACK_INTENT_KEY, '1');
      } catch(e) { console.log('[ACT_MAP] set back intent error', e); }
      location.href = "/customer/expinfo/detailExpinfo?uidKey="+uid + "&search=" + encodeURIComponent(search) + "&type=activity";
    },
    maskName(name) {
      if (!name) return '';
      const firstChar = name.charAt(0); // 첫 번째 글자
      const maskedChars = '*'.repeat(name.length - 1); // 나머지 글자를 *로 마스킹
      return firstChar + maskedChars;
    },
    goToRemark(link) {
      window.open(link);
    },

    ztf: function (t) {
      let vm = this;
      vm.viewModel.zf = t
    },
    zta: function () {
      let vm = this;
      vm.viewModel.zf--
      if (vm.viewModel.zf < 1) vm.viewModel.zf = 1
    },
    ztb: function () {
      let vm = this;
      vm.viewModel.zf++
      if (vm.viewModel.zf > vm.viewModel.zt) vm.viewModel.zf = vm.viewModel.zt
    },
    // ==================== 상태 저장/복원 ====================
    saveActivityMapState(immediate) {
      // 목록 페이지에서만 저장
      const path = (window.location && window.location.pathname) ? window.location.pathname.replace(/\/+$/, '') : '';
      if (path !== '/customer/activityMap') return;
      try {
        const state = {
          ts: Date.now(),
          areaGuid: this.expInfoListModel.areaGuid,
          activityGuid: this.expInfoListModel.activityGuid,
          activityKind: this.expInfoListModel.activityKind,
          pageNo: this.expInfoListModel.pager.pageNo,
          totalSize: this.expInfoListModel.pager.totalSize,
          list: this.expInfoListModel.list,
          mapList: this.mapListModel.list,  // 시설 목록 저장
          filters: {
            trget: this.viewYnModel.trget ? this.viewYnModel.trget.cmm_sys_cd : '',
            affiliation: this.viewYnModel.affiliation ? this.viewYnModel.affiliation.cmm_sys_cd : '',
            price: this.viewYnModel.price ? this.viewYnModel.price.cmm_sys_cd : '',
            progress: this.viewYnModel.progress ? this.viewYnModel.progress.cmm_sys_cd : ''
          },
          areaName: this.areaName,
          areaName2: this.areaName2,
          tabIdx: this.tabIdx,
          activityKindTop: this.activityKind,
          isMapExpanded: this.isMapExpanded,  // 지도 확대 상태 저장
          showMore: this.expInfoListModel.showMore,  // 더보기 버튼 표시 여부
          scrollY: window.scrollY
        };
        sessionStorage.setItem(ACT_MAP_STATE_KEY, JSON.stringify(state));
      } catch(e){ console.log('[ACT_MAP] save state error', e); }
    },
    restoreActivityMapState() {
      const raw = sessionStorage.getItem(ACT_MAP_STATE_KEY);
      if (!raw) return false;
      try {
        const st = JSON.parse(raw);
        if (Date.now() - st.ts > 15 * 60 * 1000) { // TTL 15분
          sessionStorage.removeItem(ACT_MAP_STATE_KEY);
          return false;
        }
        this.expInfoListModel.areaGuid = st.areaGuid;
        this.expInfoListModel.activityGuid = st.activityGuid;
        this.expInfoListModel.activityKind = st.activityKind;
        this.expInfoListModel.pager.pageNo = st.pageNo || 1;
        this.expInfoListModel.pager.totalSize = st.totalSize || 0;
        this.expInfoListModel.list = st.list || [];
        this.expInfoListModel.showMore = st.showMore !== undefined ? st.showMore : false;  // 더보기 버튼 복원
        this.mapListModel.list = st.mapList || [];  // 시설 목록 복원
        this.areaName = st.areaName || this.areaName;
        this.areaName2 = st.areaName2 || this.areaName2;
        this.tabIdx = st.tabIdx || this.tabIdx;
        this.activityKind = st.activityKindTop || this.activityKind;
        this.isMapExpanded = st.isMapExpanded !== undefined ? st.isMapExpanded : true;  // 지도 확대 상태 복원
        
        // Pager 재설정
        if (this.expInfoListModel.pager.totalSize > 0) {
          Pager.props = Pager.methods.createPager(this.expInfoListModel.pager, this, "list");
        }
        
        // 스크롤 복구
        this.$nextTick(()=> window.scrollTo(0, st.scrollY || 0));
        // 복원 후 상태 삭제 (뒤로가기 후 재진입 시 초기화)
        sessionStorage.removeItem(ACT_MAP_STATE_KEY);
        return true;
      } catch(e){ console.log('[ACT_MAP] restore state error', e); return false; }
    }
  }
});
